import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useBooth } from '../../../../../hooks/useBooth';
import { Booth, TeamMember } from '../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import BoothLinkedPeopleSelect from '../../../../account/Booth/BoothInfo/BoothLinkedPeopleSelect';
interface NewBoothLinkedPersonInterface {
  booth: Booth;
}

const NewBoothLinkedPerson = ({ booth }: NewBoothLinkedPersonInterface) => {
  const orgMembers = useSelector(({ common }) => common.teamUsers);

  const { t, i18n } = useTranslation();
  const { updateProp, fetchAndUpdateBooth } = useBooth();
  const [section, setSection] = useState(0);
  const [isSelectingLinkedPerson, setIsSelectingLinkedPerson] = useState(false);
  const [selectedMember, setSelectedMember] = useState<TeamMember>();

  useEffect(() => {
    if (!selectedMember) return;
    updateBoothLinkedPeople();
  }, [selectedMember]);

  async function updateBoothLinkedPeople() {
    setIsSelectingLinkedPerson(true);
    try {
      const linkedPeople = booth.linkedPeople ? [...booth.linkedPeople, { user: selectedMember }] : [{ user: selectedMember }];
      //@ts-ignore
      await updateProp(booth._id, 'linkedPeople', linkedPeople);
      toast.success(t('toasts:success-new-linked-person'));
    } catch (err) {
      toast.error((err as any)?.response?.data?.translation?.[`${i18n.language}-${i18n.language.toUpperCase()}`] || t('common:error-without-status'));
    }
    (document.activeElement as HTMLElement).blur();
  }

  const onSuccess = () => {
    fetchAndUpdateBooth(booth._id);
    setSection(0);
  };

  return (
    <div className="grid w-full my-4 place-items-center">
      {section === 0 && (
        <button
          className="flex items-center justify-center w-10 h-10 text-white rounded-full opacity-50 cursor-pointer bg-slate-700 hover:opacity-75"
          onClick={() => setSection(1)}>
          <FontAwesomeIcon icon={faPlus} />
        </button>
      )}
      {section === 1 && (
        <>
          {booth.linkedPeople && booth.linkedPeople.length < orgMembers.length && (
            <div className="grid w-full my-4 place-items-center ">
              {!isSelectingLinkedPerson && <BoothLinkedPeopleSelect booth={booth} value={selectedMember} onSuccess={onSuccess} isInline />}
              {isSelectingLinkedPerson && <CircularProgress />}
            </div>
          )}
        </>
      )}
    </div>
  );
};
export default NewBoothLinkedPerson;
